import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import usePartList from '../hooks/usePartList';
import { DoorModelPartsFragment, DoorParts } from '../queries';

interface PartsListFieldsProps {
  doorModelParts?: Partial<DoorModelPartsFragment> | null;
  doorParts?: Partial<DoorParts> | null;
  readOnly?: boolean;
  canPartsBeEdited?: boolean;
}

export default function PartsListFields({
  doorModelParts,
  doorParts,
  readOnly = false,
  canPartsBeEdited = true,
}: PartsListFieldsProps) {
  const { register } = useFormContext();
  const { isEditable } = usePartList(doorModelParts, doorParts, readOnly);
  return (
    <>
      <Grid item lg={6} xs={12}>
        <TextField
          name="lockLatch"
          label="Lock / latch"
          variant="outlined"
          fullWidth
          inputRef={register}
          inputProps={{ maxLength: 255 }}
          disabled={!isEditable('lockLatch') || !canPartsBeEdited}
        />
      </Grid>
      <Grid item lg={6} xs={12}>
        <TextField
          name="closer"
          label="Door closer"
          variant="outlined"
          fullWidth
          inputRef={register}
          inputProps={{ maxLength: 255 }}
          disabled={!isEditable('closer') || !canPartsBeEdited}
        />
      </Grid>
      <Grid item lg={6} xs={12}>
        <TextField
          name="intumescentStrip"
          label="Intumescent strip"
          variant="outlined"
          fullWidth
          inputRef={register}
          inputProps={{ maxLength: 255 }}
          disabled={!isEditable('intumescentStrip') || !canPartsBeEdited}
        />
      </Grid>
      <Grid item lg={6} xs={12}>
        <TextField
          name="hinges"
          label="Hinges"
          variant="outlined"
          fullWidth
          inputRef={register}
          inputProps={{ maxLength: 255 }}
          disabled={!isEditable('hinges') || !canPartsBeEdited}
        />
      </Grid>
      <Grid item lg={6} xs={12}>
        <TextField
          name="handles"
          label="Handles"
          variant="outlined"
          fullWidth
          inputRef={register}
          inputProps={{ maxLength: 255 }}
          disabled={!isEditable('handles') || !canPartsBeEdited}
        />
      </Grid>
      <Grid item lg={6} xs={12}>
        <TextField
          name="smokeSeals"
          label="Smoke seals"
          variant="outlined"
          fullWidth
          inputRef={register}
          inputProps={{ maxLength: 255 }}
          disabled={!isEditable('smokeSeals') || !canPartsBeEdited}
        />
      </Grid>
      <Grid item lg={6} xs={12}>
        <TextField
          name="dropSeal"
          label="Drop seal"
          variant="outlined"
          fullWidth
          inputRef={register}
          inputProps={{ maxLength: 255 }}
          disabled={!isEditable('dropSeal') || !canPartsBeEdited}
        />
      </Grid>
      <Grid item lg={6} xs={12}>
        <TextField
          name="cylinder"
          label="Cylinder"
          variant="outlined"
          fullWidth
          inputRef={register}
          inputProps={{ maxLength: 255 }}
          disabled={!isEditable('cylinder') || !canPartsBeEdited}
        />
      </Grid>
      <Grid item lg={6} xs={12}>
        <TextField
          name="letterbox"
          label="Letterbox"
          variant="outlined"
          fullWidth
          inputRef={register}
          inputProps={{ maxLength: 255 }}
          disabled={!isEditable('letterbox') || !canPartsBeEdited}
        />
      </Grid>
      <Grid item lg={6} xs={12}>
        <TextField
          name="spyhole"
          label="Spyhole"
          variant="outlined"
          fullWidth
          inputRef={register}
          inputProps={{ maxLength: 255 }}
          disabled={!isEditable('spyhole') || !canPartsBeEdited}
        />
      </Grid>
      <Grid item lg={6} xs={12}>
        <TextField
          name="thresholdStrip"
          label="Threshold strip"
          variant="outlined"
          fullWidth
          inputRef={register}
          inputProps={{ maxLength: 255 }}
          disabled={!isEditable('thresholdStrip') || !canPartsBeEdited}
        />
      </Grid>
    </>
  );
}
